// extracted by mini-css-extract-plugin
module.exports = {"statsContainer":"ResultsLayout_statsContainer__3J7H_","collapse":"ResultsLayout_collapse__1ezPC"};